import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { combineLatest, takeUntil } from "rxjs";
import { BroadcastService } from "@webapp/core/broadcast/services/broadcast.service";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { PermissionsFacade } from "@webapp/permissions/services/permissions-facade.service";
import { TasksFacade } from "@webapp/tasks/services/task-facade.service";
import { UiDrawerRef } from "@webapp/ui/drawer/abstracts/drawer-ref";
import { Task } from "../../models/tasks.models";

@Component({
  selector: "task-details",
  templateUrl: "./task-details.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskDetailsComponent implements OnInit {
  @Input() public taskId: string;

  public task: Task;
  public hasManageTasksPermission: boolean;

  constructor(
    private broadcastService: BroadcastService,
    private permissionsFacade: PermissionsFacade,
    private tasksFacade: TasksFacade,
    private destroyService$: DestroyService,
    private drawerRef: UiDrawerRef
  ) {}

  public ngOnInit(): void {
    combineLatest({
      task: this.tasksFacade.getTask$(this.taskId),
      hasPermission: this.permissionsFacade.hasPermission$("ManageTasks"),
    })
      .pipe(takeUntil(this.destroyService$))
      .subscribe(({ task, hasPermission }) => {
        this.task = task;
        this.hasManageTasksPermission = hasPermission;
        // todo error handle
      });
  }

  public updateTask($event, field: string): void {
    const update: Partial<Task> = { [field]: this.task[field] };

    this.tasksFacade
      .update$(this.taskId, { [field]: $event })
      .pipe(takeUntil(this.destroyService$))
      .subscribe({
        next: (updatedTask) => {
          this.task = updatedTask;
          this.broadcastService.emit("taskUpdated", { task: updatedTask, update: update });
        },
        error: () => {
          // todo error handle
        },
      });
  }

  public changeArchivedStatus(): void {
    this.updateTask(!this.task.archived, "archived");
  }

  public cloneTask(): void {
    this.tasksFacade
      .create$(this.task, { cloned: true })
      .pipe(takeUntil(this.destroyService$))
      .subscribe({
        next: (task) => {
          this.broadcastService.emit("taskCreated", { task });
        },
        error: () => {
          // todo error handle
        },
      });
  }

  public deleteTask(): void {
    this.tasksFacade
      .deleteTask$(this.task.id)
      .pipe(takeUntil(this.destroyService$))
      .subscribe({
        next: () => {
          this.broadcastService.emit("taskDeleted", { task: this.task });
          this.drawerRef.close();
        },
        error: () => {
          // todo error handle
        },
      });
  }
}
